import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Opa",
  "description": "",
  "published": "2006-11-05T00:00:00.000Z",
  "redirect_from": ["/blog/opa/swizec/369"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Dva dni nazaj, v petek zgodaj zjutraj, ko sem se prebudil iz spanca in prizgal racunalnik,d a bi se lotil pisanja, ker v celem dnevu na urniku ni bilo nobenega drugega opravila, je racunalnik zanikal sodelovanje in se ni prizgal. Ob vsakem poskusu je prisel natanko do trenutka, ko zacne pravilno uporabljati graficno kartico in zmrnil, odlocitev je padla, da je potrebna nova graficna kartica.`}</p>
    <p>{`Ob hitrem skoku v trgovino sem opazil, da graficne kartice za AGP vodilo niso vec tako lahko dobljiva stvar, kot so bile vcasih. Scasoma, in po nekaj trgovinah, mi je koncno uspelo najti lepega Radeon x1600, ki je VELIKO boljsi kot starta GeForce 2 MX 400.`}</p>
    <p>{`Torej sem prisel domov s prelepo crno skatlo pod pazduho in vstavil novo kartico v racunalo, ki pa se se vedno ni prav lepo prizgalo. Potrebno je obnoviti kernel. Po kar nekaj igrackanja je kernel koncno deloval pravilno in podpiral vse potrebne stvari (vedno kaj pozabim), ampak pojavili so se problemi z Xorg.`}</p>
    <p>{`Izkazalo se je, da je potrebno na novo naloziti celoten Xorg, kar pa se je slucajno izkazalo za nekaj hujsega kot sem pricakoval, saj je zahtevalo migracijo na novi modularni X. Po dolgih urah poskusanja je stvar koncno bila v priblizno delujocem stanju, ko pa se je pojavila dokoncna zelja po dvojnem ekranarstvu. Nekako pa clovek opazi, da iz nenavadnih razlogov kaj takega zahteva ponovno instalacijo celotnega KDEja.`}</p>
    <p>{`Zdaj sem torej tu, 6000 besed za casom in se vedno cakajoc instalacije nekaterih stvari. Casi, kot je ta, me pripravijo do razmisljanja zakaj je sploh trudim z Gentoojem in ne uporabljam raje kake distribucije kot naprimer Debian ali Ubuntu. Ah ja, danes je treba napisati 9000 besed, ce hocem ujeti samega sebe in priti nazaj v predviden cas, kar me sili v jok in cmizdrenje ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      